import { GridColDef } from '@mui/x-data-grid';
import { IdCardsColumnsWithCheckboxArgs } from '../../IdCards/types/IdCardTypes';
import StyledCheckbox from '../../common/styled/Checkbox';

function getColumns({
  selectedIds,
  onHeaderCheckboxClick,
  onCellCheckboxClick,
  allRowsSelected,
  isSomeRowsSelected
}: IdCardsColumnsWithCheckboxArgs): GridColDef[] {
  return [
    {
      field: 'select',
      headerName: '',
      width: 60,
      sortable: false,
      disableColumnMenu: true,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => (
        <StyledCheckbox
          checked={allRowsSelected}
          indeterminate={isSomeRowsSelected}
          onChange={onHeaderCheckboxClick}
        />
      ),
      renderCell: (params: any) => (
        <StyledCheckbox
          checked={selectedIds.includes(params.row.id)}
          onChange={() => onCellCheckboxClick(params.row.id)}
        />
      )
    },
    { field: 'name', headerName: 'Student Name', width: 180 },
    { field: 'rollNo', headerName: 'Roll No', width: 100 },
    { field: 'enrollmentNo', headerName: 'Enrollment No', width: 150 },
    { field: 'currentGradeDivision', headerName: 'Current Class', width: 150 },
    {
      field: 'rollOverGradeAndDivision',
      headerName: 'Provisionally Promoted To',
      width: 200
    },
    {
      field: 'applicableConcessions',
      headerName: 'Applicable Concessions',
      width: 600
    }
  ];
}
export { getColumns };
